import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../config/apiConfig";

const HelpCenter = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [query, setQuery] = useState("");
  const [topic, setTopic] = useState("");

  useEffect(() => {
    const fetchList = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/api/help-articles`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Failed to load help articles list:", e);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, []);

  const topics = useMemo(() => {
    const set = new Set();
    (items || []).forEach((x) => {
      const t = x.topic || x.Topic; // support both
      if (t && String(t).trim()) set.add(String(t).trim());
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [items]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return (items || []).filter((x) => {
      const t = (x.topic || x.Topic || "").toLowerCase();
      const h = (x.heading || x.Heading || "").toLowerCase();
      const slug = (x.slug || x.Slug || "").toLowerCase();

      const topicOk = !topic || t === topic.toLowerCase();
      const queryOk = !q || h.includes(q) || slug.includes(q) || t.includes(q);

      return topicOk && queryOk;
    });
  }, [items, query, topic]);

  return (
    <>
      <Header />

      <main className="rbt-main-wrapper">
        <div className="rbt-putchase-guide-area breadcrumb-style-max-width rbt-section-gapTop rbt-section-gapBottom">
          <div className="rbt-article-content-wrapper">
            <div className="content">
              <h4 style={{ fontSize: "48px" }}>Help Center</h4>

              {/* Filters */}
              <div className="row mt-4 mb-4 help-filters align-items-center">
                <div className="col-md-6 mb-2">
                  <input
                    className="form-control"
                    placeholder="Search help articles..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <select
                    className="form-control"
                    value={topic}
                    onChange={(e) => setTopic(e.target.value)}
                  >
                    <option value="">All Topics</option>
                    {topics.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-2 mb-2">
                  <button
                    className="btn btn-outline-secondary w-100"
                    type="button"
                    onClick={() => {
                      setQuery("");
                      setTopic("");
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>

              {/* List */}
              {loading ? (
                <div className="rich-html-wrapper">
                  <div className="rich-html-inner">
                    <p>Loading...</p>
                  </div>
                </div>
              ) : filtered.length === 0 ? (
                <div className="rich-html-wrapper">
                  <div className="rich-html-inner">
                    <p>No help articles found.</p>
                  </div>
                </div>
              ) : (
                <div className="card">
                  <div className="card-body">
                    <ul className="list-unstyled mb-0">
                      {filtered.map((x) => {
                        const slug = x.slug || x.Slug;
                        const heading = x.heading || x.Heading;
                        const topicLabel = x.topic || x.Topic;

                        return (
                          <li
                            key={slug}
                            className="d-flex justify-content-between align-items-center py-3"
                            style={{ borderBottom: "1px solid #eee" }}
                          >
                            <div>
                              <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                <Link to={`/help/${slug}`} style={{ textDecoration: "none" }}>
                                  {heading}
                                </Link>
                              </div>
                              {topicLabel ? (
                                <div style={{ fontSize: "13px", opacity: 0.75 }}>{topicLabel}</div>
                              ) : null}
                            </div>
                            <div style={{ opacity: 0.7 }}>
                              <i data-feather="chevron-right"></i>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <Footer />
      </main>

      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default HelpCenter;
